import { RoutingControl } from "mobility-toolbox-js/ol";

import GraphhopperRoutingControl, {
  GraphhopperRoutingProfile,
} from "../components/Editor/GraphhopperRoutingControl";

import {
  DRAW_TYPE_GROUP_LINE,
  DRAW_TYPE_GROUP_PROPERTY,
  DRAW_TYPE_PROPERTY,
  DRAW_TYPE_ROUTE,
  RoutingService,
} from "./constants";

import type { RoutingMot } from "mobility-toolbox-js/types";

import type { EnvState } from "../envConfig";

import type { Mot } from "./constants";

const createRoutingControl = (
  state: EnvState,
  mot: Mot = state.map.routingControl?.mot ??
    state.app.routingDefaultMot ??
    "foot",
): GraphhopperRoutingControl | RoutingControl => {
  let routingControl: GraphhopperRoutingControl | RoutingControl | undefined;
  const service =
    state.app.routingServiceByMot?.[mot] ?? state.app.routingService;
  if (service === RoutingService.Graphhopper) {
    routingControl = new GraphhopperRoutingControl({
      apiKey: `${state.app.graphhopperKey}`,
      // @ts-expect-error - bad typing in mobility-toolbox-js, undefined should be handled correctly
      apiParams: {},
      maxNbViaPoints: state.app.routingMaxNbViaPoints,
      modify: true,
      mot: mot as GraphhopperRoutingProfile,
      // @ts-expect-error - bad typing in mobility-toolbox-js, undefined should be handled correctly
      onRouteError: (error: Error | undefined) => {
        // We redefine it because on error we do want the that the inputs are reset
        // this.dispatchEvent(new BaseEvent("change:route"));
        // eslint-disable-next-line no-console
        console.error(error);
      },
      routingLayer: state.map.routingLayer,
    });
  } else {
    routingControl = new RoutingControl({
      apiKey: state.app.routingKey,
      // @ts-expect-error - bad typing in mobility-toolbox-js, undefined should be handled correctly
      apiParams: {},
      apiUrl: state.app.routingUrl,
      modify: true,
      mot: mot as RoutingMot,
      routingLayer: state.map.routingLayer,
      stopsApiKey: state.app.stopFinderKey,
      stopsApiUrl: state.app.stopFinderUrl,
    });
  }

  routingControl.setProperties({
    [DRAW_TYPE_GROUP_PROPERTY]: DRAW_TYPE_GROUP_LINE,
    [DRAW_TYPE_PROPERTY]: DRAW_TYPE_ROUTE,
    title: "Route zeichnen",
  });
  routingControl.active = false;
  return routingControl;
};

export default createRoutingControl;
